import {
  GET_PERSONALIZATION_CONTENT_SUCCESS,
  PERSONALIZATION_CONTENT_REQUESTING,
  RESET_PERSONALIZATION_CONTENT_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_PERSONALIZATION_CONTENT_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case PERSONALIZATION_CONTENT_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_PERSONALIZATION_CONTENT_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getPersonalizationBlockByCode = (personalizationBlock, code) => {
  if (!personalizationBlock.data) {
    return null;
  }
  const personalizationBlockIds = Object.keys(personalizationBlock.data);
  const personalizationBlockByCodeId = personalizationBlockIds.find(
    (id) => personalizationBlock.data[id].code === code
  );
  if (personalizationBlockByCodeId) {
    return personalizationBlock.data[personalizationBlockByCodeId];
  }
  return null;
};
